export class EmployeesVsAttendanceDTO {
    projectsList:string[];
    employeesCount:number[];
    attendanceCount:number[];
}